export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-100 via-background-100 to-accent-50/30 rounded-3xl overflow-hidden border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Left content */}
            <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                移动观影
              </span>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                随时随地，追剧不停
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                黄瓜影院全面适配手机与平板浏览器，无需下载App即可享受<strong>高清在线观看</strong>体验。在任何设备上打开浏览器，即刻访问<strong>电影大全</strong>与<strong>电视剧全集</strong>，<strong>不缓冲流畅播放</strong>，追剧从未如此方便。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-300">
                  <i className="ri-android-line text-accent-600"></i>
                  <span className="text-sm text-foreground-700">Android 浏览器</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-300">
                  <i className="ri-apple-line text-accent-600"></i>
                  <span className="text-sm text-foreground-700">iOS Safari</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-full border border-background-300">
                  <i className="ri-computer-line text-accent-600"></i>
                  <span className="text-sm text-foreground-700">桌面浏览器</span>
                </div>
              </div>
            </div>

            {/* Right: mock phone */}
            <div className="flex-shrink-0 px-8 pb-8 lg:px-0 lg:pb-0 lg:pr-16">
              <div className="relative w-48 md:w-56">
                <div className="rounded-[2rem] border-4 border-foreground-800 bg-foreground-900 overflow-hidden shadow-2xl">
                  <div className="aspect-[9/19] bg-gradient-to-b from-primary-600 via-primary-700 to-foreground-900 flex flex-col items-center justify-center p-4 text-center">
                    <span className="font-heading text-base font-bold text-background-50 mb-1">黄瓜影院</span>
                    <span className="text-[10px] text-background-300 mb-3">免费高清在线观看</span>
                    <div className="flex-1 flex flex-col gap-1.5 w-full">
                      {['热播推荐', '最新剧集', '电影大全', '我的片单'].map((item, i) => (
                        <div
                          key={item}
                          className={`rounded-lg px-3 py-2 text-left text-[10px] ${
                            i === 0
                              ? 'bg-accent-500 text-foreground-950 font-medium'
                              : 'bg-background-800/40 text-background-300'
                          }`}
                        >
                          <i className={`${i === 0 ? 'ri-fire-line' : i === 1 ? 'ri-timer-line' : i === 2 ? 'ri-film-line' : 'ri-bookmark-line'} mr-1`}></i>
                          {item}
                        </div>
                      ))}
                    </div>
                    <div className="mt-3 w-24 h-1.5 rounded-full bg-background-700"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}